<template>
  <el-select
      ref="select"
      multiple
      :placeholder=placeholder
      v-model="newValue"
      style="width: 192px"
      :disabled="disabled == null? false:disabled"
      clearable
  >
    <el-option
        v-for="item in list"
        :label="item[Name]"
        :value="item[Name]"
    ></el-option>
  </el-select>
</template>
<script>
import {commonGet} from "@/request"

export default {
  name: "single select",

  data() {
    return {
      list: [],
      newValue: undefined,
      nameValue: 'name',
      idValue: 'id',
    }
  },
  props: [
    'url',
    'model',
    'placeholder',
    'param',
    'Name',
    'Id', 'disabled'
  ],
  created() {
    if (this.Name != undefined) {
      this.nameValue = this.Name
    }
    if (this.Id != undefined) {
      this.idValue = this.Id
    }
    commonGet(this.url).then(res => {
      this.list = res.data
    })
  },
  methods: {
    reset() {
      this.newValue = undefined
    },
  },
  watch: {
    'model'(e) {
      this.newValue = e

    },
    'newValue'(e) {
      this.$emit('name', e)
      this.$emit('event', e)
    }
  }

}
</script>

<style scoped>

</style>
